/**
 * Custom "Browse" file uploader button
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false)=> {
	const debug = enableDebug;

	const uploadBtn = document.getElementById('js-file-uploader');
	const fileInput = document.getElementById('js-file-uploader-input');
	const fileInfo = document.getElementById('js-file-uploader-info');

	if (!uploadBtn || !fileInput || !fileInfo) return;

	uploadBtn.addEventListener('click', () => fileInput.click());

	fileInput.addEventListener('change', () => {
		fileInfo.textContent = fileInput.files.length ? fileInput.files[0].name : 'No file chosen.';
	});
};
